export const Footer = ({ onScrollTo }) => (
  <footer data-testid="footer" className="bg-bg border-t border-line">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <img
            src="/assets/brand/logo-full.png"
            alt="Essentia Bellezza"
            className="h-28 w-auto -ml-1"
          />
          <p className="mt-5 max-w-sm text-ink/60 text-sm leading-relaxed">
            Hydra Power — crema hidratante botánica para pies, de Essentia
            Bellezza. Repara, suaviza y refresca con el poder de la naturaleza.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="eyebrow text-ink/40 mb-4">Navegación</div>
          <ul className="space-y-3 text-sm text-ink/70">
            {[
              ["Experiencia", "#experiencia"],
              ["Soluciones", "#soluciones"],
              ["Ofertas", "#ofertas"],
              ["Opiniones", "#opiniones"],
            ].map(([l, h]) => (
              <li key={h}>
                <button
                  data-testid={`footer-link-${h.replace("#", "")}`}
                  onClick={() => onScrollTo(h)}
                  className="hover:text-accent transition-colors"
                >
                  {l}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="eyebrow text-ink/40 mb-4">Contacto</div>
          <ul className="space-y-3 text-sm text-ink/70">
            <li>hola@hydrapower.co</li>
            <li>+57 300 000 0000</li>
            <li>Colombia</li>
          </ul>
        </div>
      </div>
      <div className="mt-14 pt-6 border-t border-line flex flex-col sm:flex-row justify-between gap-3 text-xs text-ink/40">
        <span>© {new Date().getFullYear()} Essentia Bellezza. Todos los derechos reservados.</span>
        <span>Botones de compra en modo demostración.</span>
      </div>
    </div>
  </footer>
);
